import React, { useMemo, useCallback } from 'react';
import propTypes from 'prop-types';
import { UiTable } from 'src/ui';
import { Button, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;
;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink, Link } from 'react-router-dom';

export function ObligationsTable({ loading, obligations, onDeleteObligation }) {
  const onDelete = useCallback(obligation => {
    return () => onDeleteObligation(obligation);
  }, []);
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Creditor',
        accessor: 'obligationCreditor',
        width: 300,
        Cell: row => (
          <Link
            className="edit-link"
            to={`/obligations/edit/${row.original.id}`}
          >
            {row.value}
          </Link>
        ),
      },
      {
        Header: 'Date Opened',
        accessor: 'obligationDateOpened',
        Cell: row => (
          <Link
            className="edit-link"
            to={`/obligations/edit/${row.original.id}`}
          >
            {row.value}
          </Link>
        ),
      },
      {
        Header: 'Original Amount',
        accessor: 'obligationOriginalAmount',
        Cell: row => (
          <Link
            className="edit-link"
            to={`/obligations/edit/${row.original.id}`}
          >
            {row.value}
          </Link>
        ),
      },
      {
        Header: '',
        accessor: 'id',
        sortable: false,
        width: 62,
        resizable: false,
        Cell: row => (
          <MuiDropdown
            isAlign="right"
            renderTrigger={
              <Button isColor="white">
                <span className="icon">
                  <FontAwesomeIcon
                    icon={['fal', 'ellipsis-v']}
                    className="has-text-grey"
                    size="lg"
                  />
                </span>
              </Button>
            }
          >
              <MuiDropdownItem tag={NavLink} to={`/obligations/edit/${row.value}`}>
                Edit
              </MuiDropdownItem>
              <MuiDropdownItem tag="a" onClick={onDelete(row.original)}>
                Archive
              </MuiDropdownItem>
          </MuiDropdown>
        ),
      },
    ],
    []
  );

  return (
    <UiTable
      columns={tableColumns}
      loading={loading}
      data={obligations}
      title="Obligation"
      emptyTo="/obligations/add"
      resolveData={data =>
        data.map(obligation => ({
          ...obligation,
        }))
      }
      getTheadThProps={(_state, _rowInfo, column) => ({
        className: [
          'obligationCreditor',
          'obligationDateOpened',
          'obligationOriginalAmount',
        ].includes(column.id)
          ? 'has-text-left'
          : '',
      })}
      toNext="/people"
      toPrev="/business"
      hideNext
      hidePrev
    />
  );
}

ObligationsTable.propTypes = {
  loading: propTypes.bool.isRequired,
  obligations: propTypes.arrayOf(propTypes.object).isRequired,
  onDeleteObligation: propTypes.func.isRequired,
};
